'use client';

import { memo, useEffect } from 'react';

import { updateCartList } from '@screens/Cart';
import { updateComparisonList } from '@screens/Comparison';
import { updateFavoritesList } from '@screens/Favorites/model/slice/favoritesSlice';
import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch } from '@shared/hooks/redux';
import { WithNeedUpdateTokenProps } from '@shared/types/global';
import { RefreshTokenState } from '@widgets/RefreshTokenState/RefreshTokenState';

import { Bot } from './Bot/Bot';
import { Top } from './Top/Top';
import cls from './Header.module.scss';

type HeaderProps = {
  productsForUser: {
    cartCount: Array<{ productId: string; quantity: string; selected?: boolean }>;
    favouritesCount: string[];
    comparesCount: string[];
  };
} & WithNeedUpdateTokenProps;

export const Header = memo<HeaderProps>(
  ({ needUpdateToken, productsForUser: { cartCount, favouritesCount, comparesCount } }) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
      const handlePageShow = async () => {
        if (
          ![
            ROUTES.PERSONAL_DATA,
            ROUTES.PUBLIC_OFFER,
            ROUTES.COOKIES_POLICY,
            ROUTES.CONSENT_PERSONAL_DATA,
            ROUTES.CONSENT_PERSONAL_DATA_METRIC,
            ROUTES.USER_AGREEMENT,
            ROUTES.CONTACTS,
            ROUTES.ABOUT_COMPANY,
            ROUTES.WARRANTY,
            ROUTES.SPLIT,
            ROUTES.QUESTION_ANSWER,
            ROUTES.DELIVERY_AND_PAYMENT,
            ROUTES.EXPLOITATION,
            ROUTES.PRODUCT_CERTS,
            ROUTES.SEARCH
          ].includes(window.location.pathname as ROUTES)
        ) {
          window.location.reload();
        }
      };

      window.addEventListener('popstate', handlePageShow);

      return () => {
        window.removeEventListener('popstate', handlePageShow);
      };
    }, []);

    useEffect(() => {
      dispatch(updateCartList(cartCount));
      dispatch(updateFavoritesList(favouritesCount));
      dispatch(updateComparisonList(comparesCount));
    }, [cartCount, comparesCount, dispatch, favouritesCount]);

    return (
      <header
        data-style={'padding-lock'}
        className={cls.wrap}
      >
        <Top />
        <Bot />
        <RefreshTokenState
          redirect={false}
          withoutLoader={true}
          {...{ needUpdateToken }}
        />
      </header>
    );
  }
);
